import cx from 'classnames';
import React from 'react';
import CheckmarkIcon from '../icons/checkmark';
import styles from './checkbox.module.scss';

interface CheckboxProps {
  checked: boolean;
  onChange?: (checked: boolean) => void;
  className?: string;
  variant?: 'filled' | 'outlined' | 'outlined-gray';
  id?: string;
  label?: string; // New prop
}

export const Checkbox = ({
  checked,
  onChange,
  className,
  variant = 'filled',
  id,
  label, // Destructure new prop
}: CheckboxProps) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange?.(event.target.checked);
    }
  };

  const uniqueId = id || `checkbox-${Math.random().toString(36).substr(2, 9)}`; // Generate unique ID if not provided

  return (
    <label
      htmlFor={uniqueId}
      className={cx(styles.checkboxContainer, className)}
    >
      <input
        type="checkbox"
        id={uniqueId}
        className={styles.nativeCheckbox}
        checked={checked}
        onChange={handleChange}
      />
      <div
        className={cx(styles.visualCheckbox, styles[`variant--${variant}`])}
        aria-hidden="true"
      >
        <CheckmarkIcon className={styles.checkIcon} />
      </div>
      {label && <span className={styles.checkboxLabel}>{label}</span>}
    </label>
  );
};
